import React from 'react';

export default function YarnBallIcon({ size = 28, recording = false, asMic = false }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        filter: recording
          ? 'drop-shadow(0 0 8px rgba(240,128,128,0.9))'
          : 'drop-shadow(0 2px 4px rgba(0,0,0,0.15))',
        transition: 'filter 0.3s',
      }}
    >
      <defs>
        <radialGradient id="yarnGrad" cx="35%" cy="30%" r="70%">
          <stop offset="0%" stopColor="#F7C948" />
          <stop offset="30%" stopColor="#F4A261" />
          <stop offset="60%" stopColor="#F08080" />
          <stop offset="100%" stopColor="#C3A8E1" />
        </radialGradient>
        <radialGradient id="yarnShade" cx="60%" cy="65%" r="55%">
          <stop offset="0%" stopColor="#9B7EC8" stopOpacity="0.4" />
          <stop offset="100%" stopColor="#F08080" stopOpacity="0" />
        </radialGradient>
        <clipPath id="yarnClip">
          <circle cx="28" cy="28" r="24" />
        </clipPath>
      </defs>

      {/* Main sphere */}
      <circle cx="28" cy="28" r="24" fill="url(#yarnGrad)" />
      <circle cx="28" cy="28" r="24" fill="url(#yarnShade)" />

      {/* Texture — horizontal wrap lines */}
      <g clipPath="url(#yarnClip)" strokeLinecap="round">
        <path d="M4 22 C10 19, 18 17, 28 19 C38 21, 46 19, 52 16" stroke="rgba(255,255,255,0.45)" strokeWidth="2" fill="none"/>
        <path d="M4 28 C10 25, 18 23, 28 25 C38 27, 46 25, 52 22" stroke="rgba(255,255,255,0.4)" strokeWidth="2" fill="none"/>
        <path d="M4 34 C10 31, 18 29, 28 31 C38 33, 46 31, 52 28" stroke="rgba(255,255,255,0.35)" strokeWidth="2" fill="none"/>
        <path d="M5 40 C12 37, 20 35, 28 37 C36 39, 44 37, 51 34" stroke="rgba(255,255,255,0.25)" strokeWidth="1.5" fill="none"/>

        {/* Vertical wrap lines */}
        <path d="M16 4 C13 12, 11 20, 13 28 C15 36, 13 44, 14 52" stroke="rgba(255,255,255,0.3)" strokeWidth="1.5" fill="none"/>
        <path d="M28 4 C26 12, 25 20, 27 28 C29 36, 28 44, 28 52" stroke="rgba(255,255,255,0.3)" strokeWidth="1.5" fill="none"/>
        <path d="M40 5 C39 13, 38 21, 40 29 C42 37, 41 45, 40 52" stroke="rgba(255,255,255,0.25)" strokeWidth="1.5" fill="none"/>

        {/* Diagonal strands */}
        <path d="M6 14 C14 20, 20 28, 18 38 C16 46, 20 52, 22 56" stroke="rgba(255,255,255,0.2)" strokeWidth="1.2" fill="none"/>
        <path d="M38 6 C42 14, 44 22, 42 32 C40 40, 42 48, 40 54" stroke="rgba(255,255,255,0.2)" strokeWidth="1.2" fill="none"/>
      </g>

      {/* Highlight sheen */}
      <ellipse cx="20" cy="17" rx="8" ry="5" fill="white" opacity="0.22" transform="rotate(-25 20 17)" />
      <ellipse cx="17" cy="20" rx="3" ry="2" fill="white" opacity="0.15" transform="rotate(-25 17 20)" />

      {/* Loose thread tail */}
      <path
        d="M46 10 Q52 5 54 10 Q56 15 50 18 Q56 18 57 24"
        stroke="#F7C948"
        strokeWidth="2.5"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      {/* Mic indicator — small mic icon overlaid at bottom right */}
      {asMic && (
        <g transform="translate(36, 36)">
          <circle cx="12" cy="12" r="12" fill="white" opacity="0.92" />
          {/* Mic body */}
          <rect x="8.5" y="5" width="7" height="10" rx="3.5" fill="#F4A261" />
          {/* Mic stand */}
          <path d="M7 14 Q7 20 12 20 Q17 20 17 14" stroke="#F4A261" strokeWidth="1.8" fill="none" strokeLinecap="round"/>
          <line x1="12" y1="20" x2="12" y2="23" stroke="#F4A261" strokeWidth="1.8" strokeLinecap="round"/>
          <line x1="9" y1="23" x2="15" y2="23" stroke="#F4A261" strokeWidth="1.8" strokeLinecap="round"/>
        </g>
      )}

      {/* Recording pulse dot */}
      {recording && (
        <circle cx="46" cy="12" r="6" fill="#F08080">
          <animate attributeName="r" values="5;7;5" dur="1s" repeatCount="indefinite" />
          <animate attributeName="opacity" values="1;0.5;1" dur="1s" repeatCount="indefinite" />
        </circle>
      )}
    </svg>
  );
}
